export default "__VITE_ASSET__DXwo6dvS__"